import React from 'react'
import { Divider } from 'plume-ui'
import { CompanyFull } from '../../../types'
import { CompanyCard } from './CompanyCard'
import { EmptyCard } from '../../common/EmptyCard'

type Props = {
  list: CompanyFull[]
  className?: string
}

export const CompanyCardList: React.FC<Props> = (props) => {
  if (props.list.length === 0) {
    return <EmptyCard />
  }

  return (
    <>
      {props.list.map((c) => {
        return (
          <div key={c.id} className={props.className}>
            <CompanyCard company={c} />
            <Divider />
          </div>
        )
      })}
    </>
  )
}
